import { useEffect, useState } from 'react';
import { callMsGraphGroup } from '../../graphGroup';
import { useMsal } from '@azure/msal-react';
import { profileRequest } from '../../authConfig';
import { ProfileType } from '../../model/datatype';
import { getInfoUsers } from '../../services/ApiGetUserInfo';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

// is-mobile

export const Topbar = (props: any) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [graphData, setGraphData] = useState(false);
  const [data, setData] = useState<ProfileType | null>(null);
  const navigate = useNavigate();
  useEffect(() => {
    console.log(isMobile);
    if (isMobile) {
      navigate('/desktop-olny');
    }
    if (data === null) {
      getInfoUsers().then((response) => {
        const getData: any = response;
        setData(getData);
      });
    }
  }, [data]);

  return (
    <div className="admin-top-bar">
      <div className="row">
        <div className="col-12 col-sm-7 col-md-7"></div>
        <div className="col-12 col-sm-5 col-md-5">
          <div className="user-profile d-flex float-end">
            <div className="text-end me-2 pt-1">
              <label>{data?.employeeNameEn}</label>
              <p>Admin</p>
            </div>
            <div>
              <img src="../../../images/user.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
